<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar>
        <v-icon>call_received</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>Alta de Acuerdo</div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid>
          <v-row v-if="!selectedPersona" dense>
            <v-col>
              <span>Seleccione a una Persona</span>
            </v-col>
          </v-row>

          <v-row align="center" v-if="!selectedPersona">
            <v-col cols="12">
              <app-busqueda-personas
                :personaSeleccionada="setPersona"
              ></app-busqueda-personas>
            </v-col>
          </v-row>

          <v-row v-if="selectedPersona">
            <v-col>
              <span>Persona seleccionada</span>
            </v-col>
          </v-row>

          <v-row align="center" v-if="selectedPersona">
            <v-col cols="4">
              <v-text-field
                v-model="selectedPersona.cui"
                label="CUI(L/T) "
                key="cuil"
                :disabled="true"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="selectedPersona.nombreCompleto"
                label="Nombre"
                :disabled="true"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn color="warning" small text @click="limpiar"
                >Cancelar</v-btn
              >
            </v-col>
          </v-row>

          <!-- lista de deudas de la persona -->
          <v-container fluid v-if="selectedPersona">
            <v-card>
              <v-card-title>
                <span class="title">Créditos con Deuda</span>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  dense
                  :headers="headers"
                  :items="listDeudas"
                  :rows-per-page="pagination.itemsPerPage"
                  :options.sync="pagination"
                  v-model="listDeudasSeleccionadas"
                  :loading="loading"
                  class="elevation-1"
                  :footer-props="footer"
                  :show-select="listDeudas.length > 0"
                  item-key="id"
                >
                  <template v-slot:header.data-table-select="{ on, props }">
                    <v-checkbox
                      @change="selectAllChanged"
                      color="purple"
                      v-bind="props"
                      v-on="on"
                    ></v-checkbox>
                  </template>

                  <template v-slot:item="{ item, isSelected, select }">
                    <tr>
                      <td v-if="item.motivoNoPuedeCobrar == ''">
                        <v-simple-checkbox
                          class="caption"
                          color="green"
                          :value="isSelected"
                          @input="select($event)"
                        ></v-simple-checkbox>
                      </td>
                      <td v-else>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" dark v-on="on"
                              >warning</v-icon
                            >
                          </template>
                          <span
                            >No puede realizar un Acuerdo sobre esta deuda
                            porque: {{ item.motivoNoPuedeCobrar }}</span
                          >
                        </v-tooltip>
                      </td>

                      <td>
                        <app-acciones-comunes :personaId="model.personaId">
                        </app-acciones-comunes>
                      </td>

                      <td class="text-xs-left caption">{{ item.origen }}</td>
                      <td class="text-xs-left caption">{{ item.numero }}</td>
                      <td class="text-xs-left caption">
                        {{
                          item.detalle
                            .map((d) => d.importeCuota)
                            .reduce((a, b) => a + b, 0) | currency
                        }}
                      </td>
                      <td class="text-xs-left caption">
                        {{
                          item.detalle
                            .map((d) => d.importePunitorios)
                            .reduce((a, b) => a + b, 0) | currency
                        }}
                      </td>
                      <td class="text-xs-left caption">
                        {{
                          item.detalle
                            .map((d) => d.importeCargos)
                            .reduce((a, b) => a + b, 0) | currency
                        }}
                      </td>
                      <td class="text-xs-left caption">
                        {{
                          item.detalle
                            .map(
                              (d) =>
                                d.importeCuota +
                                d.importePunitorios +
                                d.importeCargos
                            )
                            .reduce((a, b) => a + b, 0) | currency
                        }}
                      </td>
                      <td class="text-xs-left caption">
                        <v-chip small :color="item.empresaColor" label dark>{{
                          item.empresa
                        }}</v-chip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-container>

          <!-- detalle del acuerdo -->
          <v-container fluid v-if="listDeudasSeleccionadas.length > 0">
            <v-row dense>
              <v-col cols="2">
                <v-text-field
                  v-model="totalSeleccionado"
                  label="Total Seleccionado"
                  prefix="$"
                  :disabled="true"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="model.importeCargosExtra"
                  prefix="$"
                  label="Agregar Cargos Por"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="totalAcuerdo"
                  label="Total a Reestructurar"
                  prefix="$"
                  :disabled="true"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="2">
                <v-checkbox
                  label="Condonar Deuda"
                  v-model="model.condonarDeuda"
                >
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">help_outline</v-icon>
                      </template>
                      Permite ingresar un monto a condonar de Intereses
                      Punitorios y/o Cargos de Cobranza de los Créditos con
                      Deuda
                    </v-tooltip>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col cols="2" v-if="model.condonarDeuda">
                <v-text-field
                  v-model="model.importeCondonadoPunitorios"
                  label="$ a Descontar de Punitorios"
                  @change="alta(true)"
                  :error="validadorImporteCondonadoPunitorios != ''"
                  :error-messages="validadorImporteCondonadoPunitorios"
                />
              </v-col>
              <v-col cols="2" v-if="model.condonarDeuda">
                <v-text-field
                  v-model="model.importeCondonadoCargos"
                  label="$ a Descontar de Cargos"
                  @change="alta(true)"
                  :error="validadorImporteCondonadoCargos != ''"
                  :error-messages="validadorImporteCondonadoCargos"
                />
              </v-col>
              <v-col cols="2" v-if="model.condonarDeuda">
                <v-text-field
                  v-model="totalAcuerdoConDescuentos"
                  label="Total a Reestructurar (c/Dtos)"
                  prefix="$"
                  :disabled="true"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col> Nuevo Plan de Pagos </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="2">
                <v-checkbox
                  label="Generar Anticipo por"
                  v-model="model.generarAnticipo"
                />
              </v-col>
              <v-col cols="2" v-if="model.generarAnticipo">
                <v-text-field
                  v-model="model.importeAnticipoCuota"
                  label="$ a Cuota"
                  @change="alta(true)"
                />
              </v-col>
              <v-col cols="2" v-if="model.generarAnticipo">
                <v-text-field
                  v-model="model.importeAnticipoPunitorios"
                  label="$ a Punitorios"
                  @change="alta(true)"
                />
              </v-col>
              <v-col cols="2" v-if="model.generarAnticipo">
                <v-text-field
                  v-model="model.importeAnticipoCargos"
                  label="$ a Cargos"
                  @change="alta(true)"
                />
              </v-col>
              <v-col cols="2" v-if="model.generarAnticipo">
                <v-text-field
                  v-model="model.fechaAnticipo"
                  label="para el Día"
                  type="date"
                />
              </v-col>
            </v-row>

            <v-row align="center" dense>
              <v-col cols="1"> Saldo en </v-col>
              <v-col cols="1">
                <v-text-field
                  v-model="model.cantidadCuotas"
                  label=""
                  type="number"
                />
              </v-col>
              <v-col cols="2"> cuotas de {{ importeCuota | currency }} </v-col>
              <v-col cols="2">
                <v-autocomplete
                  v-model="model.primerVencimiento"
                  :items="opcionesVencimientos"
                  item-text="descripcion"
                  item-value="id"
                  label="El 1er Vencimiento será el "
                  :menu-props="{ minWidth: '200' }"
                ></v-autocomplete>
                <!-- <v-text-field v-model="model.primerVencimiento" label="con 1er. vto el" type="date"/> -->
              </v-col>
            </v-row>

            <v-row align="center" dense>
              <v-col cols="3">
                <v-autocomplete
                  v-model="model.tipoMedioCobroId"
                  :items="listMediosCobro"
                  item-text="descripcion"
                  item-value="id"
                  label="El cobro del acuerdo será mediante"
                  :menu-props="{ minWidth: '200' }"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="model.tipoMedioCobroId == 2" no-gutters>
              <v-col cols="12">
                <app-datos-debito-credito
                  :standAloneMode="false"
                  :personaId="model.personaId"
                  :situacionLaboralActividadId="situacionLaboralActividadId"
                  :cuentaSeleccionada="model.cuentaDebito"
                ></app-datos-debito-credito>
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="alta(false)" color="success"> Confirmar Alta</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { addDays, format } from 'date-fns';
import { Decimal } from 'decimal.js';

import { mapGetters, mapMutations } from 'vuex';

export default {
  data: () => ({
    loading: false,
    saving: false,
    selectedPersona: null,
    listDeudas: [],
    listDeudasSeleccionadas: [],
    fecha: format(new Date(), 'YYYY-MM-DD'),
    totalSeleccionado: 0,
    importeCuota: 0,
    tipoMedioPagoId: 0,
    listMediosCobro: [],
    opcionesVencimientos: [],
    cbu: '',
    diaCobroId: 0,
    situacionLaboralActividadId: null,
    model: {
      personaId: null,
      importeCargosExtra: 0,
      generarAnticipo: false,
      importeAnticipoCuota: 0,
      importeAnticipoPunitorios: 0,
      importeAnticipoCargos: 0,
      fechaAnticipo: null,
      cantidadCuotas: 0,
      primerVencimiento: null,
      deudas: [],
      tipoMedioCobroId: 0,
      cuentaDebito: {},
      condonarDeuda: false,
      importeCondonadoPunitorios: 0,
      importeCondonadoCargos: 0,
    },
    pagination: {
      // definición de paginación
      sortDesc: [true],
      sortBy: [''],
      page: 1,
      itemsPerPage: 5,
    },
    footer: {
      showFirstLastPage: true,
      itemsPerPageOptions: [5, 10, 20, 50],
    },
    totalItems: 0, // va afuera de pagination
    headers: [
      // definición de columnas
      { text: 'Ver', value: 'accion', width: 80, sortable: false },
      { text: 'Origen del Crédito', value: 'origen' },
      { text: 'Número', value: 'numero' },
      { text: 'Deuda', value: 'deuda' },
      { text: 'Punitorios', value: 'punitorios' },
      { text: 'Cargos Cbza.', value: 'cargos' },
      { text: 'Total Adeudado', value: 'totalAdeudado' },
      { text: 'Empresa', value: 'empresaShort', width: 100 },
    ],
    // validadorImporteCondonadoPunitorios: ''
  }),
  created() {
    this.loadMediosCobro();
    this.model.fechaAnticipo = this.$moment(new Date()).format('YYYY-MM-DD');
    this.model.primerVencimiento = this.$moment()
      .startOf('month')
      .add(1, 'M')
      .format('YYYY-MM-DD');

    this.opcionesVencimientos.push({
      id: this.model.primerVencimiento,
      descripcion: this.$moment(this.model.primerVencimiento).format(
        'DD/MM/YYYY'
      ),
    });
    this.opcionesVencimientos.push({
      id: this.$moment(this.model.primerVencimiento)
        .add(1, 'M')
        .format('YYYY-MM-DD'),
      descripcion: this.$moment(this.model.primerVencimiento)
        .add(1, 'M')
        .format('DD/MM/YYYY'),
    });
  },
  computed: {
    ...mapGetters(['getActionFromLink', 'user']),
    totalAcuerdo: function () {
      return new Decimal(this.totalSeleccionado).plus(
        this.model.importeCargosExtra
      );
    },
    totalAcuerdoConDescuentos: function () {
      return new Decimal(this.totalSeleccionado)
        .plus(this.model.importeCargosExtra)
        .minus(
          this.model.importeCondonadoPunitorios
            ? this.model.importeCondonadoPunitorios
            : 0
        )
        .minus(
          this.model.importeCondonadoCargos
            ? this.model.importeCondonadoCargos
            : 0
        );
    },
    validadorImporteCondonadoPunitorios: function () {
      if (!this.model.condonarDeuda || !this.model.importeCondonadoPunitorios)
        return '';
      var totalPunitorios = 0;

      for (
        let index = 0;
        index < this.listDeudasSeleccionadas.length;
        index++
      ) {
        const deuda = this.listDeudasSeleccionadas[index];
        totalPunitorios = new Decimal(totalPunitorios).plus(
          deuda.detalle
            .map((d) => d.importePunitorios)
            .reduce((a, b) => a + b, 0)
        );
      }

      if (
        new Decimal(this.model.importeCondonadoPunitorios).minus(
          totalPunitorios
        ) > 0
      )
        return 'El importe no puede superar $' + totalPunitorios.toFixed(2);
      else return '';
    },
    validadorImporteCondonadoCargos: function () {
      if (!this.model.condonarDeuda || !this.model.importeCondonadoCargos)
        return '';
      var totalCargos = 0;

      for (
        let index = 0;
        index < this.listDeudasSeleccionadas.length;
        index++
      ) {
        const deuda = this.listDeudasSeleccionadas[index];
        totalCargos = new Decimal(totalCargos).plus(
          deuda.detalle.map((d) => d.importeCargos).reduce((a, b) => a + b, 0)
        );
      }

      if (new Decimal(this.model.importeCondonadoCargos).minus(totalCargos) > 0)
        return 'El importe no puede superar $' + totalCargos.toFixed(2);
      else return '';
    },
  },
  watch: {
    listDeudasSeleccionadas: function () {
      this.totalSeleccionado = 0;

      for (
        let index = 0;
        index < this.listDeudasSeleccionadas.length;
        index++
      ) {
        const deuda = this.listDeudasSeleccionadas[index];

        this.totalSeleccionado = new Decimal(this.totalSeleccionado).plus(
          deuda.detalle
            .map((d) => d.importeCuota + d.importePunitorios + d.importeCargos)
            .reduce((a, b) => a + b, 0)
        );
      }
    },
    'model.cantidadCuotas': function () {
      this.alta(true);
    },
    'model.generarAnticipo': function () {
      if (!this.model.generarAnticipo) this.alta(true);
    },
    'model.tipoMedioCobroId': function () {
      Vue.$log.debug(this.model.tipoMedioCobroId);
      if (this.model.tipoMedioCobroId != 2) this.model.cuentaDebito = {};
      //this.model.cuentaDebito.altaCuenta = false;
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'hideActiveTask',
      'hideActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    selectAllChanged(toggle) {
      this.listDeudasSeleccionadas = [];
      if (toggle) {
        for (let index = 0; index < this.listDeudas.length; index++) {
          const element = this.listDeudas[index];

          this.listDeudasSeleccionadas.push(element);
        }
      }
    },
    limpiar: function () {
      this.selectedPersona = null;
      this.listDeudas = [];
      this.listDeudasSeleccionadas = [];
    },
    setPersona(persona) {
      this.selectedPersona = persona;
      this.model.personaId = persona.personaId;
      this.loadDeudas();
    },
    async alta(simular) {
      Vue.$log.debug(this.model);
      if (!simular) {
        Vue.$log.debug('NO SIMULAR');
        if (!this.validarAlta()) return;
        Vue.$log.debug('NO SIMULAR 2');
      }

      /* if(this.model.cantidadCuotas ==0) return;

            if(this.model.generarAnticipo){
                if(this.model.importeAnticipoCuota == 0 && this.model.importeAnticipoCargos == 0) return;
            }
            else{
                this.model.importeAnticipoCuota = 0;
                this.model.importeAnticipoCargos = 0;
            } */

      this.loadingDeudas = true;

      this.model.deudas = [];

      var emp = 0;

      for (
        let index = 0;
        index < this.listDeudasSeleccionadas.length;
        index++
      ) {
        const deuda = this.listDeudasSeleccionadas[index];

        if (emp == 0) {
          emp = deuda.empresaId;
        } else {
          if (emp != deuda.empresaId) {
            this.alertWarning(
              'No puedes armar un mismo acuerdo con créditos de distintas empresas.'
            );
            return false;
          }
        }

        this.model.deudas.push({
          empresaId: deuda.empresaId,
          tipoDeuda: 1,
          deudaId: deuda.id,
          importeDeuda: deuda.detalle
            .map((d) => d.importeCuota)
            .reduce((a, b) => a + b, 0),
          importePunitorios: deuda.detalle
            .map((d) => d.importePunitorios)
            .reduce((a, b) => a + b, 0),
          importeCargos: deuda.detalle
            .map((d) => d.importeCargos)
            .reduce((a, b) => a + b, 0),
        });
      }

      //console.log(this.model);

      try {
        if (simular) {
          var result = await http.post(
            'acuerdos/simular',
            JSON.stringify({ acuerdo: this.model })
          );
          console.log(result);
          this.importeCuota = result.entity.importeCuota;
        } else {
          await http.post('acuerdos', JSON.stringify({ acuerdo: this.model }));
          Vue.$log.debug(result);

          this.alertSuccess('El Acuerdo ha sido dado de alta');
          this.limpiar();
        }
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }

      this.loadingDeudas = false;
    },
    async loadDeudas() {
      this.listDeudas = [];
      this.loadingDeudas = true;
      try {
        var result = await http.get(
          'personas/listdeudasporcobrardetallada' +
            '?empresaId=0' +
            '&id=' +
            this.model.personaId +
            '&fechaCaja=' +
            format(new Date(), 'YYYY-MM-DD')
        );

        this.listDeudas = result.list;

        // traigo la situación laboral del titular de la primera deuda, para
        // deshabilitar el día de cobro si es pasivo ANSES
        if (this.listDeudas.length > 0) {
          var datosMedioCobro = await http.get(
            'creditos/datosmediocobro' + '?creditoId=' + this.listDeudas[0].id
          );
          this.situacionLaboralActividadId =
            datosMedioCobro.situacionLaboralActividadId;
        }

        console.log(this.listDeudas);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingDeudas = false;
    },
    async loadMediosCobro() {
      this.loading = true;
      try {
        var result = await http.get('tiposmediocobro'); // traigo todas
        this.listMediosCobro = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    validarAlta() {
      if (this.model.cantidadCuotas == 0) {
        this.alertWarning('La cantidad de cuotas no puede ser 0.');
        return false;
      }

      if (this.model.generarAnticipo) {
        if (
          this.model.importeAnticipoCuota == 0 &&
          this.model.importeAnticipoCargos == 0
        )
          return false;
      } else {
        this.model.importeAnticipoCuota = 0;
        this.model.importeAnticipoCargos = 0;
      }

      if (!this.model.tipoMedioCobroId || this.model.tipoMedioCobroId == 0) {
        this.alertWarning('Debe seleccionar el medio de cobro.');
        return false;
      }

      return true;
    },
  },
};
</script>
